import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import appUtil from '@/vue-dlb/utils/app-util'
import $ from "jquery";
import idb from '@/vue-dlb/utils/idb';
import config from '@/vue-caas/config/config.js';

const isDlbMybatis = config.isDlbMybatis;

import {
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  selectDataSetByDataSetForComm,
  callByDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";


const state = {
  segItems: [],
  segTableItems: [],
  mergeViewItems: [],
  selectMergeViewItems: [],
  mergeViewItemsSource: [],
  mergeViewItemsToggle: [],
  mergeViewItemsSearch: [],
  segTableItemsSource:[],
  segTableItemsToggle: [],
  segTableItemsSearch: [],
  mergeFilter: {},
  filter: {},
  layoutWindowParam: {},
  showLoading: true,
};

const getters = {
};

const actions = {
  getMessageTreeData: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("segItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getMessageTreeData");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_ANALYSIS_LIST_STDDB_MARKUSED_FN";
    trSet.suiParam = "USER_TIMEZONE";
    let reqdata = ''
    if (isDlbMybatis) reqdata = selectDataSetByDataSetForComm(trSet);
    else reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });

  },
  getAnalyzedData: async ({ commit }, searchItems) => {   // no async
    const retSet = new ObjDataSet("segTableItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getAnalyzedData");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_ANALYSIS_LIST_ANALDATA_FN";
    trSet.suiParam = "USER_TIMEZONE";
    let reqdata = ''
    if (isDlbMybatis) reqdata = selectDataSetByDataSetForComm(trSet);
    else reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  /*
   *  203665   2020/10/16
   *  getAnalyzedData store in indexDb
   *  DataAnalysis
   */
  getAnalyzedDataIndexDb: async ({ commit }, searchItems) => {   // no async
    const retSet = new ObjDataSet("segTableItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getAnalyzedData");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_ANALYSIS_LIST_ANALDATA_FN";
    trSet.suiParam = "USER_TIMEZONE";
    let reqdata = ''
    if (isDlbMybatis) reqdata = selectDataSetByDataSetForComm(trSet);
    else reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      idb.saveData(res.data);
    });
  },
  getLayoutTreeData: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("segItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getLayoutTreeData");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_LAYOUT_LIST_STDDB_CREATED_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });

  },
  //getLayoutData ({ commit }, searchItems) {   // no async
  getLayoutData: async ({ commit }, searchItems) => {   // no async
    const retSet = new ObjDataSet("segTableItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getLayoutData");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_LAYOUT_LIST_DOCU_CREATED_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
      commit('showLoading', false);
    });
  },
  /*
   *  203665   2020/10/16
   *  getLayoutData store in indexDb
   *  DataAnalysis
   */
  getLayoutDataIndexDb: async ({ commit }, searchItems) => {   // no async
    const retSet = new ObjDataSet("segTableItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getLayoutData");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_LAYOUT_LIST_DOCU_CREATED_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      idb.saveData(res.data);
    });
  },
  getMergedDataBoth: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("segItems");
    const retSet2 = new ObjDataSet("mergeViewItems");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getMergedDataBoth");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DataAnalysisManager";
    trSet.tranMethod = "selectMergedLayout";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  createLayout: async ({ commit }, insertPayload) => {
    let insertMaster = insertPayload[0];
    let insertData = insertPayload[1];
    const retSet = new ObjDataSet("rtnPrcsNo");
    let condSet1 = new ObjDataSet("condSet1");
    let condSet2 = new ObjDataSet("condSet2");
    const trSet = new ObjTrSet("createLayout");
    condSet1 = appUtil.addDataHeader(insertMaster, condSet1);
    condSet2 = appUtil.addDataHeader(insertData, condSet2);
    trSet.AddDataSet("I", "DS01", condSet1);
    trSet.AddDataSet("I", "DS02", condSet2);
    trSet.AddDataSet("O", "DS03", retSet);
    trSet.tranID = "DataAnalysisManager";
    trSet.tranMethod = "createLayout";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  // getLayoutList: async ({ commit }, searchItems) => {
  //   const retSet = new ObjDataSet("dataSet01");
  //   let condSet = new ObjDataSet("condSet");
  //   const trSet = new ObjTrSet("getLayoutList");
  //   condSet = appUtil.addDataHeader(searchItems, condSet);
  //   trSet.AddDataSet("I", "DS01", condSet);
  //   trSet.AddDataSet("O", "DS02", retSet);
  //   trSet.tranID = "EDP_LAYOUT_LIST_DOCU_MST_SR_FN";
  //   trSet.suiParam = "USER_TIMEZONE";
  //   const reqdata = selectDataSetByDataSet(trSet);
  //   await api.putData("UserDispatcherServlet", reqdata).then(res => {
  //     commitRetDataSets(commit, res.data);
  //   });
  // },
  // deleteLayout: async ({ commit }, paramItems) => {
  //   const retSet = new ObjDataSet("dataSet01");
  //   let condSet = new ObjDataSet("condSet");
  //   const trSet = new ObjTrSet("deleteLayout");
  //   condSet = appUtil.addDataHeader(paramItems, condSet);
  //   trSet.AddDataSet("I", "DS01", condSet);
  //   trSet.AddDataSet("O", "DS02", retSet);
  //   trSet.tranID = "EDP_LAYOUT_DEL_DOCU_ALL_SP";
  //   trSet.suiParam = "USER_IDNO";
  //   const reqdata = execSPByDataSet(trSet);
  //   await api.putData("UserDispatcherServlet", reqdata).then(res => {
  //     commitRetDataSets(commit,  res.data);
  //   });
  // },
  executeMatching: async ({ commit }, payload) => {
    let insertMaster = payload[0];
    let insertData = payload[1];
    const retSet = new ObjDataSet("rtnPrcsNo");
    let condSet1 = new ObjDataSet("condSet1");
    let condSet2 = new ObjDataSet("condSet2");
    const trSet = new ObjTrSet("executeMatching");
    condSet1 = appUtil.addDataHeader(insertMaster, condSet1);
    condSet2 = appUtil.addDataHeader(insertData, condSet2);
    trSet.AddDataSet("I", "DS01", condSet1);
    trSet.AddDataSet("I", "DS02", condSet2);
    trSet.AddDataSet("O", "DS03", retSet);
    trSet.tranID = "DataAnalysisManager";
    trSet.tranMethod = "executeMatching";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  setFilter: async ({ commit }, filter) => {
    commit('SET_STORE_TOGGLE_MERGE_COMPARE_FILTER', filter);
  },
  setFilterMergeCompare: async ({ commit }, filter) => {
    commit('SET_STORE_SEARCH_MERGE_COMPARE_FILTER', filter);
  },
  setFilterAnalyzed: async ({ commit }, filter) => {
    commit('SET_STORE_ANALYZED_FILTER', filter);
  },
  toggleValueFilter: async ({ commit }, filter) => {
    commit('SET_STORE_TOGGLE_VALUAE_FILTER', filter);
  }
};

const mutations = {
  segItems (state, datarows) {
    state.segItems = datarows;
  },
  segTableItems (state, datarows) {
    state.segTableItemsSource = datarows;
    state.segTableItems = datarows;
    state.segTableItemsToggle = datarows;
    state.segTableItemsSearch = datarows;
  },
  mergeViewItems (state, datarows) {
    for (let i = 0; i < datarows.length; i++) {
      let item = datarows[i];
      if (datarows[i].SELE_YN == 'Y') {
        item._checked = true;
        state.selectMergeViewItems.push(item);
      }
    }
    state.mergeViewItemsSource = datarows;
    state.mergeViewItems = datarows;
    state.mergeViewItemsToggle = datarows;
    state.mergeViewItemsSearch = datarows;
  },
  showLoading (state, data) {
    state.showLoading = data;
  },
  'SET_STORE_TOGGLE_MERGE_COMPARE_FILTER' (state, filter) {
    let datarows = state.mergeViewItemsSource
    // let check = $( "#input-14").val();
    if($(".compare-merge-input").find("input").val() != ""){
      datarows = state.mergeViewItemsSearch;
    }
    state.filter = filter;
    let query_not_used = filter.query.not_used;
    let query_qualifier = filter.query.qualifier;
    // let query_one_value = filter.query.one_value;
    // let one_value_check = filter.query_one_value;
    let listResult = [];

    if (!query_not_used && !query_qualifier) {
      listResult = datarows;
        listResult = datarows.filter(item =>  {
          if(item.ELEM_VAL != null){
            if(item.ELEM_VAL.toLowerCase() != "not used"){
              return true;
            }
          }
          return false;
        });
    }
    if (query_not_used && query_qualifier) {
      listResult = datarows.filter(item =>  {
        if(item.ELEM_VAL != null){
          if(item.ELEM_VAL.toLowerCase() != "text"){
            return true;
          }
        }
        return false;
      });
    }
    if (query_not_used  && !query_qualifier) {
      listResult = datarows;
    }
    if (!query_not_used  && query_qualifier) {
      listResult = datarows.filter(item =>  {
        if(item.ELEM_VAL != null){
          if(item.ELEM_VAL.toLowerCase() != "text" && item.ELEM_VAL.toLowerCase() != "not used"){
            return true;
          }
        }
        return false;
      });
    }
    state.mergeViewItems = listResult;
    state.mergeViewItemsToggle = listResult;
  },
  'SET_STORE_SEARCH_MERGE_COMPARE_FILTER' (state, filter) {
    let datarows = state.mergeViewItemsSource;
    state.filter = filter;
    let query = filter.query;
    let listResult = [];
    let query_not_used = filter.filterQuery.not_used;
    let query_qualifier = filter.filterQuery.qualifier;
    // let query_one_value = filter.filterQuery.one_value;
    if ( query_not_used || query_qualifier) {
      datarows = state.mergeViewItemsToggle;
    }
    if (!query_not_used && !query_qualifier) {
      datarows = datarows.filter(item =>  {
          if(item.ELEM_VAL != null){
            if(item.ELEM_VAL.toLowerCase() != "not used"){
              return true;
            }
          }
          return false;
        });
    }
    if (query.trim() == '') {
      listResult = datarows;
    }
    listResult = datarows.filter(item =>  {
      for (const prop in item) {
        if (typeof item[prop] == 'string') {
          let propValue = item[prop].toLowerCase();
          let queryValue = query.toLowerCase();
          if (propValue.startsWith(queryValue)) {
            return true;
          }
        } else if (typeof item[prop] == 'number') {
          let propValue = item[prop].toString().toLowerCase();
          let queryValue = query.toLowerCase();
          if (propValue.startsWith(queryValue)) {
            return true;
          }
        }
      }
      return false;
    });

    state.mergeViewItems = listResult;
    state.mergeViewItemsSearch = listResult ;
  },

  'SET_STORE_ANALYZED_FILTER' (state, filter) {
    let datarows = state.segTableItemsSource;
    state.filter = filter;
    let query = filter.query;
    let listResult = [];
    let query_not_used = filter.filterQuery.not_used;
    let query_qualifier = filter.filterQuery.qualifier;
    // let query_one_value = filter.filterQuery.one_value;
    if (query_not_used || query_qualifier) {
      datarows = state.segTableItemsToggle;
    }
    if (!query_not_used && !query_qualifier) {
      datarows = datarows.filter(item =>  {
          if(item.ELEM_VAL != null){
            if(item.ELEM_VAL.toLowerCase() != "not used"){
              return true;
            }
          }
          return false;
        });
    }
    if (query.trim() == '') {
      listResult = datarows;
    }
    listResult = datarows.filter(item =>  {
      for (const prop in item) {
        if (typeof item[prop] == 'string') {
          let propValue = item[prop].toLowerCase();
          let queryValue = query.toLowerCase();
          if (propValue.startsWith(queryValue)) {
            return true;
          }
        } else if (typeof item[prop] == 'number') {
          let propValue = item[prop].toString().toLowerCase();
          let queryValue = query.toLowerCase();
          if (propValue.startsWith(queryValue)) {
            return true;
          }
        }
      }
      return false;
    });

    state.segTableItems = listResult;
    state.segTableItemsSearch = listResult ;
  },

  'SET_STORE_TOGGLE_VALUAE_FILTER' (state, filter) {
    let datarows = state.segTableItemsSource
    // let check = $( "#input-18").val();
    if($(".edi-analyzed-search").find("input").val() != ""){
      datarows = state.segTableItemsSearch;
    }
    state.filter = filter;
    let query_not_used = filter.query.not_used;
    let query_qualifier = filter.query.qualifier;
    // let query_one_value = filter.query.one_value;
    // let one_value_check = filter.query_one_value;
    let listResult = [];

    if (!query_not_used && !query_qualifier) {
      listResult = datarows;
        listResult = datarows.filter(item =>  {
          if(item.ELEM_VAL != null){
            if(item.ELEM_VAL.toLowerCase() != "not used"){
              return true;
            }
          }
          return false;
        });
    }
    if (query_not_used && query_qualifier) {
      listResult = datarows.filter(item =>  {
        if(item.ELEM_VAL != null){
          if(item.ELEM_VAL.toLowerCase() != "text"){
            return true;
          }
        }
        return false;
      });
    }
    if (query_not_used  && !query_qualifier) {
      listResult = datarows;
    }
    if (!query_not_used  && query_qualifier) {
      listResult = datarows.filter(item =>  {
        if(item.ELEM_VAL != null){
          if(item.ELEM_VAL.toLowerCase() != "text" &&  item.ELEM_VAL.toLowerCase() != "not used" ){
            return true;
          }
        }
        return false;
      });
    }
    state.segTableItems = listResult;
    state.segTableItemsToggle = listResult;
  },

  'SET_LAYOUT_WINDOW_PARAM' (state, layout) {
    let layoutWindowParam = state.layoutWindowParam;
    layoutWindowParam[layout['ROWID']] = layout;
    state.layoutWindowParam = layoutWindowParam;
  },
  'DELETE_LAYOUT_WINDOW_PARAM' (state, layout) {
    let layoutWindowParam = state.layoutWindowParam;
    delete layoutWindowParam[layout['ROWID']];
    state.layoutWindowParam = layoutWindowParam;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
